import { defineStyle } from '@chakra-ui/react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { mode } from '@chakra-ui/theme-tools';

const variantOutline = defineStyle((props) => {
    const { colorScheme: c } = props;
    const borderColor = mode('gray.200', 'whiteAlpha.300')(props);

    return {
        border: '1px solid',
        borderColor: c === 'gray' ? borderColor : 'currentColor',
        '.chakra-button__group[data-attached][data-orientation=horizontal] > &:not(:last-of-type)':
        { marginEnd: '-1px' },
        '.chakra-button__group[data-attached][data-orientation=vertical] > &:not(:last-of-type)':
        { marginBottom: '-1px' },
        _hover: {
            bgColor: c === 'charcoal' ? 'charcoal.25' : 'gray.200',
        },
        _active: {
            bgColor: c === 'charcoal' ? 'charcoal.25' : 'gray.200',
        },
    };
});

const variantRoundedSolid = defineStyle((props) => {
    const { colorScheme: c } = props;

    const background = mode(`${c}.500`, `${c}.200`)(props);

    return {
        bg: background,
        color: mode('white', 'gray.800')(props),
        fontWeight: '500',
        letterSpacing: '.02em',
        _hover: {
            bg: 'transparent',
            borderColor: `${c}.500`,
            color: `${c}.500`,
            _disabled: {
                bg: background,
            },
        },
        _active: { bg: mode(`${c}.700`, `${c}.400`)(props) },
        borderRadius: 'full',
        border: '1px solid',
        borderColor: background,
    };
});

const variantRoundedOutline = defineStyle((props) => {
    const { colorScheme: c } = props;

    return ({
        border: '1px solid',
        borderColor: `${c}.200`,
        borderRadius: 'full',
        '.chakra-button__group[data-attached][data-orientation=horizontal] > &:not(:last-of-type)':
        { marginEnd: '-1px' },
        '.chakra-button__group[data-attached][data-orientation=vertical] > &:not(:last-of-type)':
        { marginBottom: '-1px' },
        fontWeight: '500',
        letterSpacing: '.02em',
        _hover: {
            borderColor: `${c}.500`,
        },
    });
});

const underlineThin = defineStyle(() => ({
    border: 'none',
    padding: 0,
    textDecoration: 'underline',
    _hover: {
        textDecoration: 'none',
    },
}));

const defaultOutline = defineStyle(() => ({
    borderColor: 'muted.50',
    borderWidth: '1px',
    bgColor: 'transparent',
    colorScheme: 'muted.700',
    _hover: {
        bgColor: 'muted.50',
        color: 'muted.700',
    },
}));

export const buttonTheme = {
    sizes: {
        'cta-lg': defineStyle({
            h: '12',
            minW: '12',
            fontSize: 'lg',
            px: '8',
            py: '7',
        }),
        'cta-md': defineStyle({
            h: '10',
            minW: '10',
            fontSize: 'md',
            px: '6',
            py: '6',
        }),
        'cta-sm': defineStyle({
            h: '8',
            minW: '8',
            fontSize: 'sm',
            px: '4',
            py: '5',
        }),
    },
    variants: {
        outline: variantOutline,
        'default-outline': defaultOutline,
        'rounded-outline': variantRoundedOutline,
        'rounded-solid': variantRoundedSolid,
        'underline-thin': underlineThin,
    },
};
